import { render, staticRenderFns } from "./PointsDraggable.vue?vue&type=template&id=e2d84fc8&scoped=true&"
import script from "./PointsDraggable.vue?vue&type=script&lang=js&"
export * from "./PointsDraggable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d84fc8",
  null
  
)

export default component.exports